var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleOutline24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49967 0.833252C2.19967 0.833252 0.333008 2.69992 0.333008 4.99992C0.333008 7.29992 2.19967 9.16659 4.49967 9.16659C6.79967 9.16659 8.66634 7.29992 8.66634 4.99992C8.66634 2.69992 6.79967 0.833252 4.49967 0.833252ZM4.91634 4.58325V2.91658H4.08301V4.58325H2.41634V5.41658H4.08301V7.08325H4.91634V5.41658H6.58301V4.58325H4.91634ZM1.16634 4.99992C1.16634 6.83742 2.66217 8.33325 4.49967 8.33325C6.33717 8.33325 7.83301 6.83742 7.83301 4.99992C7.83301 3.16242 6.33717 1.66659 4.49967 1.66659C2.66217 1.66659 1.16634 3.16242 1.16634 4.99992Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutline24Px);
export default __webpack_public_path__ + "static/media/add_circle_outline_24px.87f56fca8d33a939f84e086483f7d084.svg";
export { ForwardRef as ReactComponent };